export default "__VITE_ASSET__b286d6b7__"